<template>
    <v-dialog v-model="open"
              max-width="600">
        <v-card :title="t('photo')">
            <v-card-text>
                <v-divider v-if="divider" style="width: 400px;"></v-divider>
                <v-carousel v-if="photos.length > 1"
                            v-model="currentPhotoIndex"
                            height="400"
                            hide-delimiter-background
                            show-arrows="hover">
                    <v-carousel-item v-for="(photo, index) in photos"
                                     :key="index">
                        <v-img :src="photo"
                               height="100%"
                               width="100%"
                               contain />
                    </v-carousel-item>
                </v-carousel>
                <v-img v-else
                       :src="photos[0]"
                       :height="singleHeight"
                       width="100%"
                       contain />
                <div v-if="photos.length > 1" class="text-center mt-2">
                    <span class="text-caption">{{ currentPhotoIndex + 1 }} / {{ photos.length }}</span>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :text="t('close')"
                       variant="plain"
                       @click="open = false"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script src="./model.js"></script>
<style src="./style.css"></style>
